<template>
  <fragment>
     <div class="row align-items-center justify-content-center">
                    <!-- Start col -->
                    <div class="col-md-6 col-lg-6 col-xl-3" v-for="item in cuser.companies" v-bind:key="item.companyId">
                        <div class="card m-b-30">
                            <div class="card-body p-0">
                                <div class="pricing text-center">
                                    <div class="pricing-top">
                                      <img class="img-fluid" :src="`assets/images/logo/${item.companyId}.svg`"/>
                                        
                                       
                                    </div>
                                   
                                    <div class="pricing-bottom pricing-bottom-basic">
                                        <div class="pricing-btn">
                                            <button type="button" class="btn btn-success font-16" @click="redirect(item.companyId)">Crea</button>
                                        </div>
                                    </div>
                                </div> 
                            </div>
                        </div>
                    </div>
                  
                    <!-- End col -->                    
                   
                </div>
    
  </fragment>
</template>

<script>


export default {
  data() {
    return {
      
    };
  },
 computed: {

     cuser() {
      return this.$store.state.user;
    },
  },
  components: {
  
  },
  name: "ContractInsert",
  beforeMount() {
    if(this.cuser.companies.length==1){

this.redirect(this.cuser.companies[0].companyId);
    }
  },
  methods: {
   redirect(cid){
 this.$router.push({ name: "route-contract-edit", params: { cid: cid } });

   }
  },
};
</script>
